import React from 'react';

function MentorMenteesMentorshipNotes() {
  return (
    <div className="card border-0 shadow-sm rounded-3 bg-white">
              <div className="card-header bg-white border-bottom border-light-subtle p-3 d-flex align-items-center justify-content-between">
                <h6 className="fw-bold mb-0 text-dark">My Mentorship Notes</h6>
                <button className="btn btn-sm btn-outline-secondary font-500 rounded-pill px-3" >+ Add Note</button>
              </div>
              <div className="card-body p-4 text-center text-muted font-13">
                📝 No notes yet. Add private notes about your mentees to track topics discussed, follow-ups, and observations.
              </div>
            </div>
  )
}

export default MentorMenteesMentorshipNotes;